import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';

import { userEmailState, userSettingsState } from '@store';

import { fetchLiveRampEnvelope, getLiveRamp, isEnvelopeExpired } from './helpers';

export const useLiveRamp = () => {
  const email = useRecoilValue(userEmailState);
  const settings = useRecoilValue(userSettingsState);

  useEffect(() => {
    const { envelope, timestamp } = getLiveRamp();

    const shouldFetchLiveRampEnvelope = !!(email && (!envelope || (timestamp && isEnvelopeExpired(timestamp))));
    const shouldRefreshLiveRampEnvelope = !!(email && envelope && !(timestamp && isEnvelopeExpired(timestamp)));

    if (shouldFetchLiveRampEnvelope) {
      fetchLiveRampEnvelope({ email, settings });
    } else if (shouldRefreshLiveRampEnvelope) {
      fetchLiveRampEnvelope({ envelope, refresh: true, settings });
    }
  }, [email, settings]);
  return null;
};
